// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (max-device-width: 768px) {
  .btn-hero {
    border-radius: 10px;
  }

  .btn-hero:before {
    border-radius: 10px;
  }

  .wrapper-bg {
    background-color: #cbbaa6;
  }

  .wrapper {
    background-color: #ecebe6;
    display: block;
    position: relative;
    padding-top: 30px;
    padding-bottom: 30px;
    height: 100%;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    display: block;
  }

  .bg-image {
    background-size: cover;
    /* <------ */
    background-repeat: no-repeat;
    background-position: 30% center;
    width: calc(100% - 120px);
    height: 60vh;
    border-radius: 20px;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }

  .hero-col {
    display: inline-block;
    grid-template-columns: auto;
    gap: 10px;
    height: 100%;
    align-items: center;
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }

  .hero-bg-col-1 {
    padding: 25vh 0px 0px 30px;
    margin-bottom: 0%;
    animation: fadeIn 5s;
  }

  .hero-bg-col-1 .header-title-left {
    font-family: "Nelphim";
    font-size: 4.5em;
    color: white;
  }

  .hero-bg-col-1 .header-subtitle {
    color: #fff;
    position: absolute;
    margin-top: 10vh;
  }

  .header-button {
    border: 1px solid #fff;
    border-radius: 10px;
    background-color: #000;
    color: #fff;
    position: absolute;
    bottom: 30px;
    left: 30px;
    display: flex;
    align-items: center;
  }

  .hero-bg-col-2 {
    top: 35%;
    padding: 0px 0px 0px 30px;
    right: unset;
    text-align: left;
    animation: fadeIn 5s;
  }

  .hero-bg-col-2 .header-title-right {
    font-family: "Nelphim";
    font-size: 4.5em;
    color: white;
  }

  .hero-bg-col-2 .header-subtitle {
    color: #fff;
  }

  .btn-hero-group {
    left: 90px;
  }

  .btn-value {
    padding: 16px;
    border-radius: 20px;
    margin-bottom: 16px;
  }

  .img-value {
    border-radius: 20px;
  }

  .section-feature-button {
    margin-top: -100px;
  }

  .el .el-image {
    border-radius: 20px;
  }

  .el-button {
    border-radius: 10px;
  }

  .parallax-image-url {
    width: 50%;
  }
}

@media only screen and (max-device-width: 480px) {
  .wrapper-bg {
    background-color: #cbbaa6;
  }

  .wrapper {
    background-color: #ecebe6;
    display: block;
    position: relative;
    padding-top: 15px;
    padding-bottom: 30px;
    height: 100%;
    width: 100%;
    max-width: 1366px;
    margin-left: auto;
    margin-right: auto;
    display: block;
  }

  .bg-image {
    background-size: cover;
    /* <------ */
    background-repeat: no-repeat;
    background-position: 35% center;
    width: calc(100% - 60px);
    height: calc(100vh - 80px - 45px);
    border-radius: 10px;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }

  .hero-col {
    display: inline-block;
    grid-template-columns: auto;
    gap: 10px;
    height: 100%;
    align-items: center;
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }

  .hero-bg-col-1 {
    padding: 25vh 0px 0px 30px;
    margin-bottom: 0%;
    animation: fadeIn 5s;
  }

  .hero-bg-col-1 .header-title-left {
    font-family: "Nelphim";
    font-size: 3.5em;
    color: white;
  }

  .hero-bg-col-1 .header-subtitle {
    color: #fff;
    position: absolute;
    margin-top: 15vh;
  }

  .btn-hero .btn-text {
    padding: 10px 10px !important;
  }

  .header-button {
    border: 1px solid #fff;
    border-radius: 10px;
    background-color: #000;
    color: #fff;
    position: absolute;
    bottom: 30px;
    left: 30px;
    display: flex;
    align-items: center;
  }

  .hero-bg-col-2 {
    top: 35%;
    padding: 0px 0px 0px 30px;
    right: unset;
    text-align: left;
    animation: fadeIn 5s;
  }

  .hero-bg-col-2 .header-title-right {
    font-family: "Nelphim";
    font-size: 3.5em;
    color: white;
  }

  .hero-bg-col-2 .header-subtitle {
    color: #fff;
  }

  .section-intro {
    display: block;
    max-width: 1366px;
    padding: 60px 0px 0px 0px;
    margin-left: auto;
    margin-right: auto;
  }

  .section-intro .section-item-1 {
    width: calc(100% - 60px);
    padding: unset;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }

  .section-intro .section-item-2 {
    width: calc(100% - 60px);
    padding: 30px 0 0 0;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }

  .section-intro .section-button .btn-primary {
    width: 100%;
    justify-content: space-between;
  }

  .section-feature {
    max-width: 1366px;
    padding: 30px 0px 10px 0px;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
  }

  .section-feature .section-feature-title-group {
    text-align: center;
    margin-top: 30px;
    margin-bottom: 30px;
    width: calc(100% - 60px);
    margin-left: auto;
    margin-right: auto;
  }

  .section-feature .section-feature-title-group .section-tag {
    justify-content: center;
  }

  .section-feature .section-feature-title-group .section-feature-title {
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
  }

  .section-feature .section-feature-title-group .section-feature-desc {
    margin-top: 12px;
    width: calc(100vw - 60px);
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
  }

  .section-feature .section-item-1 {
    width: calc(100% - 60px);
    padding: 30px 30px 30px 60px;
  }

  .section-feature .section-item-2 {
    width: calc(100% - 60px);
    padding: 30px 60px 30px 30px;
  }

  .section-button {
    margin-top: 30px;
  }

  .section-value {
    display: block;
    width: 100%;
    max-width: 1366px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 60px;
    padding-bottom: 60px;
  }

  .section-value .section-item-1 {
    width: calc(100% - 60px);
    display: block;
    margin-left: auto;
    margin-right: auto;
    padding: unset;
  }

  .section-value .section-item-2 {
    display: none;
  }

  .btn-value-group-web {
    display: none;
  }

  .btn-value-group-mobile {
    display: block;
    margin-top: 30px;
  }

  .img-value-web {
    display: none;
  }

  .btn-value {
    text-align: left;
    padding: 20px;
    border-radius: 10px;
    border: 1px solid #f1f1f1;
    margin-bottom: 30px;
    color: #333;
    background-color: #ecebe6;
  }

  .btn-value .section-detail-value {
    margin-top: 20px;
  }

  .btn-value .section-detail-value .main {
    margin-bottom: 12px;
  }

  .btn-value:last-child {
    margin-bottom: 0px;
  }

  img.btn-value-img {
    display: block;
    width: 100%;
    border-radius: 10px;
  }

  .btn-value:hover {
    background-color: #7ba7c2;
  }

  .btn-value:hover .section-detail-title .main {
    color: #fcfcfc;
  }

  .btn-value:hover .section-detail-title .section-detail-btn {
    color: #ecebe6;
  }

  .img-value {
    display: block;
    border-radius: 30px;
    width: 100%;
  }

  .btn-hero-group {
    position: absolute;
    margin-top: -20%;
    left: 60px;
    display: flex;
    align-items: center;
  }

  .btn-hero {
    background: rgba(252, 252, 252, 0.2);
    backdrop-filter: blur(10px);
    border: 1px solid #ecebe6;
    color: #fcfcfc;
    border-radius: 10px;
    position: relative;
    z-index: 20;
    transition:none;
    display: flex;
    align-items: center;
    width: max-content;
  }

  .btn-hero:before {
    border-radius: 10px;
    background: rgba(252, 252, 252, 0.2);
    position: absolute;
    display: flex;
    align-items: center;
    content: "";
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    transition: 0.3s all ease-in-out;
    z-index: -1;
  }

  .btn-hero svg {
    position: relative;
    padding: 0em 0em 0em 10px;
  }

  .btn-hero:hover {
    background-color: unset;
    left: unset;
    bottom: unset;
    padding-left: 0px;
    color: #fff;
  }

  .btn-hero:hover svg {
    width: 20px;
    height: 20px;
    position: relative;
    padding: 0em 0em 0em 10px;
    left: unset;
    bottom: unset;

  }

  .btn-hero:hover:before {
    width: 100%;
  }

  .btn-section {
    display: flex;
    align-items: center;
  }

  .section-feature-cards {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .wrap {
    width: 100%;
    padding: 0px 30px;
    display: block;
    justify-content: space-between;
  }

  .el-group {
    width: 100%;
  }

  .el {
    position: relative;
    margin: 0px;
    box-sizing: border-box;
    text-align: center;
    border-radius: 10px;
  }

  .el p {
    display: none;
  }

  .el .el-image {
    transform-origin: 50% 50;
    width: 100%;
    transform: scale(1);
    transition: transform 0.3s ease-out;
    border-radius: 10px;
    margin-bottom: 20px;
  }

  .el:hover {
    transform: scale(1);
    background-color: #fff;
    padding-top: 10px;
  }

  .el-group:hover p {
    display: flex;
    justify-content: space-between;
    padding: 0px 24px;
    color: #777;
  }

  .el-group:hover .el-image {
    padding: 12px;
    width: 100%;
    width: -webkit-fill-available;
    transition: transform 0.3s ease-in;
  }

  .el-image-shadow {
    position: relative;
    margin: 0px 12px;
    box-sizing: border-box;
    text-align: center;
    border-radius: 10px;
    display: none;
  }

  .shadow {
    mask-image: linear-gradient(transparent, transparent, transparent, rgba(0, 0, 0, 0.5));
    transform-origin: 50% 50;
    width: 100%;
    transform: scale(1);
    transition: transform 0.3s ease-out;
    border-radius: 30px;
    transform: rotateX(180deg);
  }

  .el-group:hover .shadow {
    padding: 0px 24px;
    width: 100%;
    width: -webkit-fill-available;
    transition: transform 0.3s ease-in;
    border-radius: 30px;
  }

  .el-button-group {
    position: absolute;
    bottom: 40px;
    left: 20px;
  }

  .el-group:hover .el-button-group {
    bottom: 42px;
    left: 42px;
  }

  .el-button {
    border-radius: 10px;
    border: 1px solid #ecebe6;
    background: rgba(252, 252, 252, 0.2);
    backdrop-filter: blur(10px);
    color: #fcfcfc;
  }

  .section-feature-button {
    display: block;
    position: relative;
    margin-top: 0px;
    width: calc(100vw - 60px);
    margin-left: auto;
    margin-right: auto;
    padding-bottom: 60px;
  }

  .section-feature-button .btn-primary {
    width: 100%;
    justify-content: space-between;
  }

  .wellness-section {
    display: flex;
    max-width: 1366px;
    padding: 30px 60px;
    margin-left: auto;
    margin-right: auto;
  }

  .parallax-section {
    padding-top: 60px;
    border-bottom-right-radius: 36px;
    border-bottom-left-radius: 36px;
    background: #ecebe5;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;
  }

  .parallax {
    min-height: 100vh;
    position: relative;
  }

  .parallax-web {
    display: none;
  }

  .parallax-mobile {
    display: block;
    width: 100%;
    overflow: hidden;
  }

  img.parallax-img-mobile {
    width: calc(100% - 60px);
    display: block;
    padding-bottom: 30px;
    margin-left: auto;
    margin-right: auto;
  }

  .parallax-content {
    position: relative;
    width: calc(100% - 60px);
    height: unset;
    overflow: hidden;
    margin-left: auto;
    margin-right: auto;
    padding: unset;
  }

  .parallax-content-group {
    display: block;
    max-width: 1366px;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
  }

  .parallax-image-1,
  .parallax-image-2,
  .parallax-image-3,
  .parallax-image-4,
  .parallax-image-5,
  .parallax-image-6 {
    width: 100%;
    display: block;
  }

  .parallax-text-section-1,
  .parallax-text-section-2,
  .parallax-text-section-3,
  .parallax-text-section-4,
  .parallax-text-section-5,
  .parallax-text-section-6 {
    width: 100%;
    display: block;
  }

  .parallax-image-url {
    display: block;
    position: relative;
    border-radius: 10px;
    width: 60%;
    margin-bottom: 0px;
  }

  .parallax-text {
    display: block;
    position: relative;
    width: 70%;
    border-radius: 10px;
    border: 1px solid #ecebe6;
    box-shadow: 0px 119px 33px 0px rgba(135, 135, 135, 0), 0px 76px 31px 0px rgba(135, 135, 135, 0.01), 0px 43px 26px 0px rgba(135, 135, 135, 0.02), 0px 19px 19px 0px rgba(135, 135, 135, 0.04), 0px 5px 10px 0px rgba(135, 135, 135, 0.04);
    backdrop-filter: blur(10px);
    background: rgba(252, 252, 252, 0.6);
    padding: 20px;
    display: block;
    color: #777;
  }

  .parallax-title {
    margin-bottom: 12px;
    width: 100%;
    color: #333;
  }

  .parallax-content-1 {
    padding-top: 0;
    margin-bottom: 30px;
  }

  .parallax-image-url-1 {
    margin-left: 40%;
  }

  .parallax-text-1 {
    margin-left: 0%;
    margin-top: -30px;
  }

  .parallax-content-2 {
    padding-top: 0;
    margin-bottom: 30px;
  }

  .parallax-image-url-2 {
    margin-left: 0%;
  }

  .parallax-text-2 {
    margin-top: -30px;
    margin-left: 20%;
  }

  .parallax-content-3 {
    padding-top: 0;
    margin-bottom: 30px;
  }

  .parallax-image-url-3 {
    margin-left: 40%;
  }

  .parallax-text-3 {
    margin-left: 0%;
    margin-top: -30px;
  }

  .parallax-content-4 {
    padding-top: 0;
    margin-bottom: 30px;
  }

  .parallax-image-url-4 {
    margin-left: 0%;
  }

  .parallax-text-4 {
    margin-top: -30px;
    margin-left: 20%;
  }

  .parallax-content-5 {
    padding-top: 0;
    margin-top: 0px !important;
    margin-bottom: 30px;
  }

  .parallax-image-url-5 {
    margin-left: 40%;
  }

  .parallax-text-5 {
    margin-left: 0%;
    margin-top: -30px;
  }

  .parallax-content-group.parallax-content-6 {
    width: unset;
  }

  .parallax-image-url-6 {
    margin-left: 0%;
  }

  .parallax-text-6 {
    margin-top: -30px;
    margin-left: 20%;
    margin-bottom: 0px;
  }

  .react-photo-album--image {
    border-radius: 10px;
  }

  .gallery-section {
    max-width: 1366px;
    margin-left: auto;
    margin-right: auto;
    display: block;
    padding-top: 60px;
    padding-bottom: 60px;
  }

  .section-title-gallery-group {
    display: block;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    padding: unset;
    color: #fcfcfc;
    padding-bottom: 30px;
  }

  .section-title-gallery-group .section-title-gallery {
    width: calc(100vw - 60px);
    padding: 0px 30px 30px 30px;
  }

  .section-title-gallery-group .section-desc-gallery {
    width: calc(100vw - 60px);
    padding: 0px 30px 0px 30px;
  }

  .react-photo-album--columns {
    justify-content: space-between;
    padding: 0px 30px;
  }

  .section-gallery-button {
    color: #fcfcfc;
    text-align: center;
    margin-top: 30px;
  }

  .gallery-button {
    margin-top: 12px;
    display: flex;
    justify-content: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/style/home_mobile.css"],"names":[],"mappings":"AAAA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,4BAA4B;IAC5B,+BAA+B;IAC/B,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,2BAA2B;IAC3B,SAAS;IACT,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE;MACE,UAAU;IACZ;;IAEA;MACE,UAAU;IACZ;EACF;;EAEA;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,QAAQ;IACR,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,4BAA4B;IAC5B,+BAA+B;IAC/B,wBAAwB;IACxB,iCAAiC;IACjC,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,2BAA2B;IAC3B,SAAS;IACT,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE;MACE,UAAU;IACZ;;IAEA;MACE,UAAU;IACZ;EACF;;EAEA;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,QAAQ;IACR,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;IACxB,cAAc;IACd,cAAc;IACd,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;IACxB,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;IACjB,0BAA0B;IAC1B,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;IACxB,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;IACxB,4BAA4B;EAC9B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,wBAAwB;IACxB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,oCAAoC;IACpC,2BAA2B;IAC3B,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,oCAAoC;IACpC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;IACvB,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,aAAa;;EAEf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,8BAA8B;EAChC;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;IACxB,WAAW;IACX,mBAAmB;IACnB,mCAAmC;IACnC,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,WAAW;IACX,6BAA6B;IAC7B,kCAAkC;EACpC;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,sFAAsF;IACtF,wBAAwB;IACxB,WAAW;IACX,mBAAmB;IACnB,mCAAmC;IACnC,mBAAmB;IACnB,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,6BAA6B;IAC7B,kCAAkC;IAClC,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,oCAAoC;IACpC,2BAA2B;IAC3B,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,gCAAgC;IAChC,+BAA+B;IAC/B,mBAAmB;IACnB,uFAAuF;EACzF;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;IACxB,cAAc;IACd,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,wBAAwB;IACxB,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;EACb;;EAEA;;;;;;IAME,WAAW;IACX,cAAc;EAChB;;EAEA;;;;;;IAME,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,yBAAyB;IACzB,wOAAwO;IACxO,2BAA2B;IAC3B,oCAAoC;IACpC,aAAa;IACb,cAAc;IACd,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,WAAW;EACb;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;IACzB,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;IAC9B,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,uBAAuB;EACzB;AACF","sourcesContent":["@media only screen and (max-device-width: 768px) {\n  .btn-hero {\n    border-radius: 10px;\n  }\n\n  .btn-hero:before {\n    border-radius: 10px;\n  }\n\n  .wrapper-bg {\n    background-color: #cbbaa6;\n  }\n\n  .wrapper {\n    background-color: #ecebe6;\n    display: block;\n    position: relative;\n    padding-top: 30px;\n    padding-bottom: 30px;\n    height: 100%;\n    width: 100%;\n    margin-left: auto;\n    margin-right: auto;\n    display: block;\n  }\n\n  .bg-image {\n    background-size: cover;\n    /* <------ */\n    background-repeat: no-repeat;\n    background-position: 30% center;\n    width: calc(100% - 120px);\n    height: 60vh;\n    border-radius: 20px;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .hero-col {\n    display: inline-block;\n    grid-template-columns: auto;\n    gap: 10px;\n    height: 100%;\n    align-items: center;\n  }\n\n  @keyframes fadeIn {\n    0% {\n      opacity: 0;\n    }\n\n    100% {\n      opacity: 1;\n    }\n  }\n\n  .hero-bg-col-1 {\n    padding: 25vh 0px 0px 30px;\n    margin-bottom: 0%;\n    animation: fadeIn 5s;\n  }\n\n  .hero-bg-col-1 .header-title-left {\n    font-family: \"Nelphim\";\n    font-size: 4.5em;\n    color: white;\n  }\n\n  .hero-bg-col-1 .header-subtitle {\n    color: #fff;\n    position: absolute;\n    margin-top: 10vh;\n  }\n\n  .header-button {\n    border: 1px solid #fff;\n    border-radius: 10px;\n    background-color: #000;\n    color: #fff;\n    position: absolute;\n    bottom: 30px;\n    left: 30px;\n    display: flex;\n    align-items: center;\n  }\n\n  .hero-bg-col-2 {\n    top: 35%;\n    padding: 0px 0px 0px 30px;\n    right: unset;\n    text-align: left;\n    animation: fadeIn 5s;\n  }\n\n  .hero-bg-col-2 .header-title-right {\n    font-family: \"Nelphim\";\n    font-size: 4.5em;\n    color: white;\n  }\n\n  .hero-bg-col-2 .header-subtitle {\n    color: #fff;\n  }\n\n  .btn-hero-group {\n    left: 90px;\n  }\n\n  .btn-value {\n    padding: 16px;\n    border-radius: 20px;\n    margin-bottom: 16px;\n  }\n\n  .img-value {\n    border-radius: 20px;\n  }\n\n  .section-feature-button {\n    margin-top: -100px;\n  }\n\n  .el .el-image {\n    border-radius: 20px;\n  }\n\n  .el-button {\n    border-radius: 10px;\n  }\n\n  .parallax-image-url {\n    width: 50%;\n  }\n}\n\n@media only screen and (max-device-width: 480px) {\n  .wrapper-bg {\n    background-color: #cbbaa6;\n  }\n\n  .wrapper {\n    background-color: #ecebe6;\n    display: block;\n    position: relative;\n    padding-top: 15px;\n    padding-bottom: 30px;\n    height: 100%;\n    width: 100%;\n    max-width: 1366px;\n    margin-left: auto;\n    margin-right: auto;\n    display: block;\n  }\n\n  .bg-image {\n    background-size: cover;\n    /* <------ */\n    background-repeat: no-repeat;\n    background-position: 35% center;\n    width: calc(100% - 60px);\n    height: calc(100vh - 80px - 45px);\n    border-radius: 10px;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .hero-col {\n    display: inline-block;\n    grid-template-columns: auto;\n    gap: 10px;\n    height: 100%;\n    align-items: center;\n  }\n\n  @keyframes fadeIn {\n    0% {\n      opacity: 0;\n    }\n\n    100% {\n      opacity: 1;\n    }\n  }\n\n  .hero-bg-col-1 {\n    padding: 25vh 0px 0px 30px;\n    margin-bottom: 0%;\n    animation: fadeIn 5s;\n  }\n\n  .hero-bg-col-1 .header-title-left {\n    font-family: \"Nelphim\";\n    font-size: 3.5em;\n    color: white;\n  }\n\n  .hero-bg-col-1 .header-subtitle {\n    color: #fff;\n    position: absolute;\n    margin-top: 15vh;\n  }\n\n  .btn-hero .btn-text {\n    padding: 10px 10px !important;\n  }\n\n  .header-button {\n    border: 1px solid #fff;\n    border-radius: 10px;\n    background-color: #000;\n    color: #fff;\n    position: absolute;\n    bottom: 30px;\n    left: 30px;\n    display: flex;\n    align-items: center;\n  }\n\n  .hero-bg-col-2 {\n    top: 35%;\n    padding: 0px 0px 0px 30px;\n    right: unset;\n    text-align: left;\n    animation: fadeIn 5s;\n  }\n\n  .hero-bg-col-2 .header-title-right {\n    font-family: \"Nelphim\";\n    font-size: 3.5em;\n    color: white;\n  }\n\n  .hero-bg-col-2 .header-subtitle {\n    color: #fff;\n  }\n\n  .section-intro {\n    display: block;\n    max-width: 1366px;\n    padding: 60px 0px 0px 0px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .section-intro .section-item-1 {\n    width: calc(100% - 60px);\n    padding: unset;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .section-intro .section-item-2 {\n    width: calc(100% - 60px);\n    padding: 30px 0 0 0;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .section-intro .section-button .btn-primary {\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .section-feature {\n    max-width: 1366px;\n    padding: 30px 0px 10px 0px;\n    margin-left: auto;\n    margin-right: auto;\n    width: 100%;\n  }\n\n  .section-feature .section-feature-title-group {\n    text-align: center;\n    margin-top: 30px;\n    margin-bottom: 30px;\n    width: calc(100% - 60px);\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .section-feature .section-feature-title-group .section-tag {\n    justify-content: center;\n  }\n\n  .section-feature .section-feature-title-group .section-feature-title {\n    max-width: 100%;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .section-feature .section-feature-title-group .section-feature-desc {\n    margin-top: 12px;\n    width: calc(100vw - 60px);\n    max-width: 100%;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .section-feature .section-item-1 {\n    width: calc(100% - 60px);\n    padding: 30px 30px 30px 60px;\n  }\n\n  .section-feature .section-item-2 {\n    width: calc(100% - 60px);\n    padding: 30px 60px 30px 30px;\n  }\n\n  .section-button {\n    margin-top: 30px;\n  }\n\n  .section-value {\n    display: block;\n    width: 100%;\n    max-width: 1366px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 60px;\n    padding-bottom: 60px;\n  }\n\n  .section-value .section-item-1 {\n    width: calc(100% - 60px);\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n    padding: unset;\n  }\n\n  .section-value .section-item-2 {\n    display: none;\n  }\n\n  .btn-value-group-web {\n    display: none;\n  }\n\n  .btn-value-group-mobile {\n    display: block;\n    margin-top: 30px;\n  }\n\n  .img-value-web {\n    display: none;\n  }\n\n  .btn-value {\n    text-align: left;\n    padding: 20px;\n    border-radius: 10px;\n    border: 1px solid #f1f1f1;\n    margin-bottom: 30px;\n    color: #333;\n    background-color: #ecebe6;\n  }\n\n  .btn-value .section-detail-value {\n    margin-top: 20px;\n  }\n\n  .btn-value .section-detail-value .main {\n    margin-bottom: 12px;\n  }\n\n  .btn-value:last-child {\n    margin-bottom: 0px;\n  }\n\n  img.btn-value-img {\n    display: block;\n    width: 100%;\n    border-radius: 10px;\n  }\n\n  .btn-value:hover {\n    background-color: #7ba7c2;\n  }\n\n  .btn-value:hover .section-detail-title .main {\n    color: #fcfcfc;\n  }\n\n  .btn-value:hover .section-detail-title .section-detail-btn {\n    color: #ecebe6;\n  }\n\n  .img-value {\n    display: block;\n    border-radius: 30px;\n    width: 100%;\n  }\n\n  .btn-hero-group {\n    position: absolute;\n    margin-top: -20%;\n    left: 60px;\n    display: flex;\n    align-items: center;\n  }\n\n  .btn-hero {\n    background: rgba(252, 252, 252, 0.2);\n    backdrop-filter: blur(10px);\n    border: 1px solid #ecebe6;\n    color: #fcfcfc;\n    border-radius: 10px;\n    position: relative;\n    z-index: 20;\n    transition:none;\n    display: flex;\n    align-items: center;\n    width: max-content;\n  }\n\n  .btn-hero:before {\n    border-radius: 10px;\n    background: rgba(252, 252, 252, 0.2);\n    position: absolute;\n    display: flex;\n    align-items: center;\n    content: \"\";\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    transition: 0.3s all ease-in-out;\n    z-index: -1;\n  }\n\n  .btn-hero svg {\n    position: relative;\n    padding: 0em 0em 0em 10px;\n  }\n\n  .btn-hero:hover {\n    background-color: unset;\n    left: unset;\n    bottom: unset;\n    padding-left: 0px;\n    color: #fff;\n  }\n\n  .btn-hero:hover svg {\n    width: 20px;\n    height: 20px;\n    position: relative;\n    padding: 0em 0em 0em 10px;\n    left: unset;\n    bottom: unset;\n\n  }\n\n  .btn-hero:hover:before {\n    width: 100%;\n  }\n\n  .btn-section {\n    display: flex;\n    align-items: center;\n  }\n\n  .section-feature-cards {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n  }\n\n  .wrap {\n    width: 100%;\n    padding: 0px 30px;\n    display: block;\n    justify-content: space-between;\n  }\n\n  .el-group {\n    width: 100%;\n  }\n\n  .el {\n    position: relative;\n    margin: 0px;\n    box-sizing: border-box;\n    text-align: center;\n    border-radius: 10px;\n  }\n\n  .el p {\n    display: none;\n  }\n\n  .el .el-image {\n    transform-origin: 50% 50;\n    width: 100%;\n    transform: scale(1);\n    transition: transform 0.3s ease-out;\n    border-radius: 10px;\n    margin-bottom: 20px;\n  }\n\n  .el:hover {\n    transform: scale(1);\n    background-color: #fff;\n    padding-top: 10px;\n  }\n\n  .el-group:hover p {\n    display: flex;\n    justify-content: space-between;\n    padding: 0px 24px;\n    color: #777;\n  }\n\n  .el-group:hover .el-image {\n    padding: 12px;\n    width: 100%;\n    width: -webkit-fill-available;\n    transition: transform 0.3s ease-in;\n  }\n\n  .el-image-shadow {\n    position: relative;\n    margin: 0px 12px;\n    box-sizing: border-box;\n    text-align: center;\n    border-radius: 10px;\n    display: none;\n  }\n\n  .shadow {\n    mask-image: linear-gradient(transparent, transparent, transparent, rgba(0, 0, 0, 0.5));\n    transform-origin: 50% 50;\n    width: 100%;\n    transform: scale(1);\n    transition: transform 0.3s ease-out;\n    border-radius: 30px;\n    transform: rotateX(180deg);\n  }\n\n  .el-group:hover .shadow {\n    padding: 0px 24px;\n    width: 100%;\n    width: -webkit-fill-available;\n    transition: transform 0.3s ease-in;\n    border-radius: 30px;\n  }\n\n  .el-button-group {\n    position: absolute;\n    bottom: 40px;\n    left: 20px;\n  }\n\n  .el-group:hover .el-button-group {\n    bottom: 42px;\n    left: 42px;\n  }\n\n  .el-button {\n    border-radius: 10px;\n    border: 1px solid #ecebe6;\n    background: rgba(252, 252, 252, 0.2);\n    backdrop-filter: blur(10px);\n    color: #fcfcfc;\n  }\n\n  .section-feature-button {\n    display: block;\n    position: relative;\n    margin-top: 0px;\n    width: calc(100vw - 60px);\n    margin-left: auto;\n    margin-right: auto;\n    padding-bottom: 60px;\n  }\n\n  .section-feature-button .btn-primary {\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .wellness-section {\n    display: flex;\n    max-width: 1366px;\n    padding: 30px 60px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .parallax-section {\n    padding-top: 60px;\n    border-bottom-right-radius: 36px;\n    border-bottom-left-radius: 36px;\n    background: #ecebe5;\n    box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;\n  }\n\n  .parallax {\n    min-height: 100vh;\n    position: relative;\n  }\n\n  .parallax-web {\n    display: none;\n  }\n\n  .parallax-mobile {\n    display: block;\n    width: 100%;\n    overflow: hidden;\n  }\n\n  img.parallax-img-mobile {\n    width: calc(100% - 60px);\n    display: block;\n    padding-bottom: 30px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .parallax-content {\n    position: relative;\n    width: calc(100% - 60px);\n    height: unset;\n    overflow: hidden;\n    margin-left: auto;\n    margin-right: auto;\n    padding: unset;\n  }\n\n  .parallax-content-group {\n    display: block;\n    max-width: 1366px;\n    margin-left: auto;\n    margin-right: auto;\n    width: 100%;\n  }\n\n  .parallax-image-1,\n  .parallax-image-2,\n  .parallax-image-3,\n  .parallax-image-4,\n  .parallax-image-5,\n  .parallax-image-6 {\n    width: 100%;\n    display: block;\n  }\n\n  .parallax-text-section-1,\n  .parallax-text-section-2,\n  .parallax-text-section-3,\n  .parallax-text-section-4,\n  .parallax-text-section-5,\n  .parallax-text-section-6 {\n    width: 100%;\n    display: block;\n  }\n\n  .parallax-image-url {\n    display: block;\n    position: relative;\n    border-radius: 10px;\n    width: 60%;\n    margin-bottom: 0px;\n  }\n\n  .parallax-text {\n    display: block;\n    position: relative;\n    width: 70%;\n    border-radius: 10px;\n    border: 1px solid #ecebe6;\n    box-shadow: 0px 119px 33px 0px rgba(135, 135, 135, 0), 0px 76px 31px 0px rgba(135, 135, 135, 0.01), 0px 43px 26px 0px rgba(135, 135, 135, 0.02), 0px 19px 19px 0px rgba(135, 135, 135, 0.04), 0px 5px 10px 0px rgba(135, 135, 135, 0.04);\n    backdrop-filter: blur(10px);\n    background: rgba(252, 252, 252, 0.6);\n    padding: 20px;\n    display: block;\n    color: #777;\n  }\n\n  .parallax-title {\n    margin-bottom: 12px;\n    width: 100%;\n    color: #333;\n  }\n\n  .parallax-content-1 {\n    padding-top: 0;\n    margin-bottom: 30px;\n  }\n\n  .parallax-image-url-1 {\n    margin-left: 40%;\n  }\n\n  .parallax-text-1 {\n    margin-left: 0%;\n    margin-top: -30px;\n  }\n\n  .parallax-content-2 {\n    padding-top: 0;\n    margin-bottom: 30px;\n  }\n\n  .parallax-image-url-2 {\n    margin-left: 0%;\n  }\n\n  .parallax-text-2 {\n    margin-top: -30px;\n    margin-left: 20%;\n  }\n\n  .parallax-content-3 {\n    padding-top: 0;\n    margin-bottom: 30px;\n  }\n\n  .parallax-image-url-3 {\n    margin-left: 40%;\n  }\n\n  .parallax-text-3 {\n    margin-left: 0%;\n    margin-top: -30px;\n  }\n\n  .parallax-content-4 {\n    padding-top: 0;\n    margin-bottom: 30px;\n  }\n\n  .parallax-image-url-4 {\n    margin-left: 0%;\n  }\n\n  .parallax-text-4 {\n    margin-top: -30px;\n    margin-left: 20%;\n  }\n\n  .parallax-content-5 {\n    padding-top: 0;\n    margin-top: 0px !important;\n    margin-bottom: 30px;\n  }\n\n  .parallax-image-url-5 {\n    margin-left: 40%;\n  }\n\n  .parallax-text-5 {\n    margin-left: 0%;\n    margin-top: -30px;\n  }\n\n  .parallax-content-group.parallax-content-6 {\n    width: unset;\n  }\n\n  .parallax-image-url-6 {\n    margin-left: 0%;\n  }\n\n  .parallax-text-6 {\n    margin-top: -30px;\n    margin-left: 20%;\n    margin-bottom: 0px;\n  }\n\n  .react-photo-album--image {\n    border-radius: 10px;\n  }\n\n  .gallery-section {\n    max-width: 1366px;\n    margin-left: auto;\n    margin-right: auto;\n    display: block;\n    padding-top: 60px;\n    padding-bottom: 60px;\n  }\n\n  .section-title-gallery-group {\n    display: block;\n    width: 100%;\n    margin-left: auto;\n    margin-right: auto;\n    padding: unset;\n    color: #fcfcfc;\n    padding-bottom: 30px;\n  }\n\n  .section-title-gallery-group .section-title-gallery {\n    width: calc(100vw - 60px);\n    padding: 0px 30px 30px 30px;\n  }\n\n  .section-title-gallery-group .section-desc-gallery {\n    width: calc(100vw - 60px);\n    padding: 0px 30px 0px 30px;\n  }\n\n  .react-photo-album--columns {\n    justify-content: space-between;\n    padding: 0px 30px;\n  }\n\n  .section-gallery-button {\n    color: #fcfcfc;\n    text-align: center;\n    margin-top: 30px;\n  }\n\n  .gallery-button {\n    margin-top: 12px;\n    display: flex;\n    justify-content: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
